import React, { useState, useEffect } from "react";
import PasswordResetForm from "./passwordResetForm";
import dexter_logo from "../../img/dexter-logo.svg";
import BarLoader from "react-spinners/BarLoader";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import "./styles/resetLink.scss";
import axios from "axios";

export default function ResetLink() {
  const [isValid, setIsValid] = useState(false);
  const [checking, setChecking] = useState(true);
  const [passWordUpdated, setPassWordUpdated] = useState(false);
  const [resetting, setRestting] = useState(false);
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get(
      "unique_token"
    );
    if (!token) {
      setIsValid(false);
      setChecking(false);
    } else
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/api/users/api/v1/verify-unique-token?unique_token=${token}`
        )
        .then((res) => {
          setChecking(false);
          setIsValid(res.data.is_valid);
        })
        .catch((err) => console.log(err));
  }, []);

  const resetPassword = (newPass) => {
    setRestting(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/users/api/v1/update-password`,
        {
          unique_token: new URLSearchParams(window.location.search).get(
            "unique_token"
          ),
          password: newPass,
        }
      )
      .then((res) => {
        setPassWordUpdated(true);
        setRestting(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="reset-link-container">
      <Link to={"/signin"} className="logo">
        <img src={dexter_logo} alt="sign-in" />
      </Link>

      <h2>Reset password</h2>
      <div style={{ position: "relative" }}>
        {passWordUpdated && (
          <div className="password-change-success">
            <p>Password changed successfully.</p>
            <NavLink to="/signin">Log in</NavLink>
          </div>
        )}
        {!checking && (
          <div>
            {isValid === true ? (
              <PasswordResetForm callBack={resetPassword} />
            ) : (
              <div className="invalid-link">
                This is not a valid reset link !
              </div>
            )}
          </div>
        )}
        {(checking || resetting) && (
          <div className="loader-absolute">
            <BarLoader
              className="loader"
              color="#e2136e"
              // size={30}
              height={10}
              width="50%"
              loading={true}
            />{" "}
            <p>Wait for a moment</p>
          </div>
        )}
      </div>
    </div>
  );
}
